import React from 'react';
import { IAuditoriaCashRichResultado } from '../interfaces/IAuditoriaCashRich';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado: IAuditoriaCashRichResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (v: number) =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoCashRich: React.FC<Props> = ({ resultado, onSelecionar }) => {
  const temAviso = resultado.totalAvisos > 0;
  const borderColor = temAviso ? '#f59e0b' : '#22c55e';
  const badgeClass  = temAviso ? 'badge bg-warning text-dark' : 'badge bg-success';

  return (
    <div
      className='auditoria-card'
      style={{ borderLeft: `4px solid ${borderColor}`, cursor: 'pointer' }}
      onClick={() => onSelecionar('AUDITORIA_CASH_RICH')}
    >
      <div className='d-flex justify-content-between align-items-start'>
        <div>
          <h5 className='mb-1'>Ineficiência Financeira — Cash-Rich com Dívida Cara</h5>
          <p className='text-muted mb-2' style={{ fontSize: '0.85rem' }}>
            Disponibilidades (1.01.01.01 + 1.01.01.02) superiores ao passivo oneroso (2.01.03.01 + 2.02.03.01).
            Lei 6.404/76 Art. 177 · RIR/2018 Art. 367 · CPC 00.
          </p>
        </div>
        <span className={badgeClass}>
          {temAviso ? `${resultado.totalAvisos} AVISO(S)` : 'CONCILIADO'}
        </span>
      </div>

      <div className='row g-2 mt-1'>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: temAviso ? '#fef3c7' : '#f0fdf4' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Impacto Fiscal Estimado (34%)</div>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: temAviso ? '#92400e' : '#16a34a' }}>
              {formatCurrency(resultado.impactoFiscalTotal)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Juros Estimados (SELIC Série 4189)</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temAviso ? '#92400e' : '#374151' }}>
              {formatCurrency(resultado.impactoFinanceiroTotal)}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Empresas com Aviso</div>
            <div style={{ fontSize: '1rem', fontWeight: 600, color: temAviso ? '#92400e' : '#374151' }}>
              {resultado.totalAvisos}
            </div>
          </div>
        </div>
        <div className='col-md-3'>
          <div className='p-2 rounded' style={{ backgroundColor: '#f9fafb' }}>
            <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Categoria</div>
            <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#374151' }}>
              Controle Preventivo de Tesouraria
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditoriaResumoCashRich;
